/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CfdOrderRequest } from '../models';
// @ts-ignore
import type { CfdSettingResponse } from '../models';
// @ts-ignore
import type { CfdSummaryResponse } from '../models';
// @ts-ignore
import type { KeyStat } from '../models';
// @ts-ignore
import type { PostOrderResponse } from '../models';
// @ts-ignore
import type { Trading212ErrorResponse } from '../models';
/**
 * Trading212CFDApi - axios parameter creator
 * @export
 */
export const Trading212CFDApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve CFD accounts summary information from Trading212
         * @summary Get CFD accounts summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-cfd/accounts-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve CFD instrument settings from Trading212
         * @summary Get CFD instrument settings
         * @param {string} instrumentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentSettings: async (instrumentCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentCode' is not null or undefined
            assertParamExists('getInstrumentSettings', 'instrumentCode', instrumentCode)
            const localVarPath = `/api/trading212-cfd/instrument-settings/{instrumentCode}`
                .replace(`{${"instrumentCode"}}`, encodeURIComponent(String(instrumentCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve key financial statistics for a specific ticker symbol from Trading212 CFD
         * @summary Get key statistics
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyStats: async (ticker: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getKeyStats', 'ticker', ticker)
            const localVarPath = `/api/trading212-cfd/key-stats/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open a new CFD position on Trading212
         * @summary Open CFD position
         * @param {CfdOrderRequest} cfdOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openPosition: async (cfdOrderRequest: CfdOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cfdOrderRequest' is not null or undefined
            assertParamExists('openPosition', 'cfdOrderRequest', cfdOrderRequest)
            const localVarPath = `/api/trading212-cfd/open-position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cfdOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trading212CFDApi - functional programming interface
 * @export
 */
export const Trading212CFDApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Trading212CFDApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve CFD accounts summary information from Trading212
         * @summary Get CFD accounts summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CfdSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CFDApi.getAccountsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve CFD instrument settings from Trading212
         * @summary Get CFD instrument settings
         * @param {string} instrumentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstrumentSettings(instrumentCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CfdSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstrumentSettings(instrumentCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CFDApi.getInstrumentSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve key financial statistics for a specific ticker symbol from Trading212 CFD
         * @summary Get key statistics
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeyStats(ticker: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KeyStat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeyStats(ticker, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CFDApi.getKeyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Open a new CFD position on Trading212
         * @summary Open CFD position
         * @param {CfdOrderRequest} cfdOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openPosition(cfdOrderRequest: CfdOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openPosition(cfdOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CFDApi.openPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Trading212CFDApi - factory interface
 * @export
 */
export const Trading212CFDApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Trading212CFDApiFp(configuration)
    return {
        /**
         * Retrieve CFD accounts summary information from Trading212
         * @summary Get CFD accounts summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsSummary(options?: RawAxiosRequestConfig): AxiosPromise<CfdSummaryResponse> {
            return localVarFp.getAccountsSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve CFD instrument settings from Trading212
         * @summary Get CFD instrument settings
         * @param {string} instrumentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentSettings(instrumentCode: string, options?: RawAxiosRequestConfig): AxiosPromise<CfdSettingResponse> {
            return localVarFp.getInstrumentSettings(instrumentCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve key financial statistics for a specific ticker symbol from Trading212 CFD
         * @summary Get key statistics
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyStats(ticker: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KeyStat>> {
            return localVarFp.getKeyStats(ticker, options).then((request) => request(axios, basePath));
        },
        /**
         * Open a new CFD position on Trading212
         * @summary Open CFD position
         * @param {CfdOrderRequest} cfdOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openPosition(cfdOrderRequest: CfdOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostOrderResponse> {
            return localVarFp.openPosition(cfdOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Trading212CFDApi - object-oriented interface
 * @export
 * @class Trading212CFDApi
 * @extends {BaseAPI}
 */
export class Trading212CFDApi extends BaseAPI {
    /**
     * Retrieve CFD accounts summary information from Trading212
     * @summary Get CFD accounts summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CFDApi
     */
    public getAccountsSummary(options?: RawAxiosRequestConfig) {
        return Trading212CFDApiFp(this.configuration).getAccountsSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve CFD instrument settings from Trading212
     * @summary Get CFD instrument settings
     * @param {string} instrumentCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CFDApi
     */
    public getInstrumentSettings(instrumentCode: string, options?: RawAxiosRequestConfig) {
        return Trading212CFDApiFp(this.configuration).getInstrumentSettings(instrumentCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve key financial statistics for a specific ticker symbol from Trading212 CFD
     * @summary Get key statistics
     * @param {string} ticker 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CFDApi
     */
    public getKeyStats(ticker: string, options?: RawAxiosRequestConfig) {
        return Trading212CFDApiFp(this.configuration).getKeyStats(ticker, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open a new CFD position on Trading212
     * @summary Open CFD position
     * @param {CfdOrderRequest} cfdOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CFDApi
     */
    public openPosition(cfdOrderRequest: CfdOrderRequest, options?: RawAxiosRequestConfig) {
        return Trading212CFDApiFp(this.configuration).openPosition(cfdOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

